import React, { useRef, useEffect, useContext, useState } from 'react'
import { Grid, Selector, Slider, Switch } from 'antd-mobile'
import { } from 'antd'

type FacePupCompHeaderProps = {
    name: string
    Icon?: React.ReactNode
}

const FacePupCompHeader = (props: FacePupCompHeaderProps) => {
    const {
        name,
        Icon,
    } = props

    return (
        <div
            style={{ display: 'flex', alignItems: 'center', lineHeight: '24px' }}
        >
            {Icon}
            <span
                style={{
                    fontSize: '14px',
                    fontWeight: 500,
                    color: '#131155',
                    lineHeight: '18px',
                    textShadow: '0px 2px 10px rgba(0,0,0,0.1)'
                }}
            >{name}</span>
        </div>
    )
}

export default FacePupCompHeader
